import {mergeTo} from '#core/utils/config-utils.js';
import {isMobile} from '#core/utils/context-utils.js';

import {AbstractVisualFeature, allVisuals} from '#core/application/modules/visual-feature.js';
import {BasePalette} from '#core/application/modules/base-palette.js';

import {applicationViewFactory} from './application-view.factory';

import SCHEMA from './application-view.schema.yaml';
import PALETTE_SCHEMA from './application-view.palette-schema.yaml';

class ApplicationViewFeature extends AbstractVisualFeature {
    get name() {
        return 'ApplicationView';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        const {backToTopHide, _mobile_backToTopHide} = this.config;

        return mergeTo(applicationViewFactory(PALETTE), {
            AppViewSportsbook: {
                applicationFooter: {
                    hide: true,
                },
                backToTopButtonToggle: {
                    hide: BasePalette.isAvantgarde() || (isMobile() ? _mobile_backToTopHide : backToTopHide),
                },
            },
        });
    }
}

export const ApplicationView = new ApplicationViewFeature(allVisuals);
